import { GiftIcon, TruckIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useSignedInAccount } from '../../../contexts/AccountContext';
import { useSite } from '../../../contexts/SiteContext';
import { dayShort, upcomingDeliveries } from '../../../utils/account';
import type { Subscription } from '../../../core/types/account';
type Props = {
  sub: Subscription;
  untilGift: number;
};

/** Het ritme kiezen, met de komende leveringen eronder — zo zie je meteen wat een keuze doet. */
export function SubscriptionRhythm({
  sub,
  untilGift
}: Props) {
  const {
    policy
  } = useSite();
  const {
    subscription
  } = useSignedInAccount();
  const {
    intervals
  } = policy.subscription;
  return <section aria-labelledby="rhythm-title" className="bg-shell p-5 ring-1 ring-line sm:p-6" data-id="element-6206" data-mp="1jg3xg4r27gco">
      <h2 id="rhythm-title" className="text-[15px] text-ink" data-id="element-6207" data-mp="1oeouxwexflxf">
        Ritme
      </h2>
      <p id="rhythm-hint" className="mt-1 text-[13px] text-muted" data-id="element-6208" data-mp="1t9uh8wc8r2m1">
        Hoe vaak we een levering sturen.
      </p>
      <div role="group" aria-labelledby="rhythm-title" aria-describedby="rhythm-hint" className="mt-4 flex flex-wrap gap-1.5" data-id="element-6209" data-mp="2gd3c3xejm697">
        {intervals.map(w => {
        const on = sub.intervalWeeks === w;
        return <button key={w} type="button" aria-pressed={on} onClick={async () => {
          // De keuze en de leveringen eronder veranderen meteen; de melding bevestigt dat het bewaard is.
          if (!on && (await subscription({
            type: 'setInterval',
            weeks: w
          }))) toast.success(`Ritme aangepast: elke ${w} weken`);
        }} className={`whitespace-nowrap rounded-full px-3.5 py-2.5 text-[13px] tabular-nums transition-[background-color,color,box-shadow] duration-150 ease-soft ${on ? 'bg-ink text-shell' : 'text-ink ring-1 ring-line hover:ring-ink/40'}`} data-id="element-6210" data-mp="26e41wae4q2k3">
              Elke {w} weken
            </button>;
      })}
      </div>
      <h3 className="sr-only" data-id="element-6211" data-mp="1b5tod63tpevk">Komende leveringen</h3>
      <ol className="mt-5 space-y-2 border-t border-line pt-4" aria-live="polite" data-id="element-6212" data-mp="1b6bvwyvxrfis">
        {upcomingDeliveries(sub).map((d, i) => <li key={d} className="flex items-center justify-between text-[14px]" data-id="element-6213" data-mp="1g6psnks3731i" data-mpi={i}>
            <span className="flex items-center gap-2 text-ink" data-id="element-6214" data-mp="11fqqoslrbcqw">
              <TruckIcon className="h-3.5 w-3.5 text-muted" strokeWidth={1.5} aria-hidden="true" data-id="element-6215" data-mp="16e1yyywelf70" />
              {dayShort(d)}
            </span>
            {i + 1 === untilGift && <span className="flex items-center gap-1 text-[12px] text-clay" data-id="element-6216" data-mp="wh5zfiohg3el">
                <GiftIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-6217" data-mp="ihecutjwheoz" /> met cadeau
              </span>}
          </li>)}
      </ol>
    </section>;
}